import { defineComponent as o } from "vue";
const n = o({
  render() {
    var e, r;
    return (r = (e = this.$slots).default) === null || r === void 0 ? void 0 : r.call(e);
  }
});
export {
  n as Wrapper
};
